import { Component, h } from 'preact'
import classNames from 'classnames'
import { GroupedItemsList, ItemsList} from "./interfaces";
import DropdownGroupedItemList from "./item-lists/DropdownGroupedItemList";
import DropdownItemList from "./item-lists/DropdownItemList";

interface Props {
  type: string,
  align: string,
  items: ItemsList | GroupedItemsList,
  displayListUpwards: boolean,
  hasSearch: boolean
}

interface State {
  isOpen: boolean
}

function isGrouped (items: ItemsList | GroupedItemsList): items is GroupedItemsList {
  return 'groupName' in items[0]
}

class DropdownList extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      isOpen: true
    }
  }

  render (props: Props, state: State) {
    const { type, align, items, displayListUpwards, hasSearch } = props
    const { isOpen } = state

    if (!isOpen) return null

    const classes = classNames(
      'control-dropdown__list',
      type ? `control-dropdown__list--${type}` : null,
      `control-dropdown__list--${align}`,
      displayListUpwards ? `control-dropdown__list--up` : null
    )
    if (!items.length) return null

    if (isGrouped(items)) {
      return (<DropdownGroupedItemList items={items} classes={classes}/>)
    }

    return (<DropdownItemList items={items} classes={classes} hasSearch={hasSearch}/>)
  }
}

export default DropdownList
